import { Theme } from '@emotion/react';
import { SxProps } from '@mui/system';

const styles = {
  cardContainer: {
    backgroundColor: 'secondary.main',
  },
  footerContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  footerLabel: {
    fontSize: 12,
    color: 'common.grey850',
  },
  footerValue: {
    fontSize: 14,
    color: 'common.grey850',
    fontWeight: '500',
  },
  fieldContainer: {
    display: 'flex',
    gap: '23px',
    mt: '24px',
  },
  labelStyle: {
    wordWrap: 'normal',
    whiteSpace: 'normal',
    fontSize: 12,
    textAlign: 'left',
    minWidth: '80px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
